import type { CreateOrderRequest } from '~entities/order';

import type { OrderFormValues } from '../ui/order-form';

export function convertFormValuesToOrder(
  values: OrderFormValues,
  productId: string
): CreateOrderRequest {
  return {
    shopOrderId: values.orderNumber,
    posId: values.posId,
    productId,
    items: values.items.map((item) => ({
      name: item.name.trim(),
      category: item.category,
      quantity: +item.quantity,
      price: +item.price,
      isUsed: !!item.isUsed,
    })),
    customer: {
      name: values.firstName?.trim(),
      surname: values.lastName?.trim(),
      phone: values.phone,
      email: values.email,
    },
  };
}
